export const percentageData = [
  {
    key: '40',
    value: '40',
  },
  {
    key: '50',
    value: '50',
  },
  {
    key: '60',
    value: '60',
  },
];

export const MinNumAward = [
  {
    key: '3',
    value: '3',
  },
  {
    key: '4',
    value: '4',
  },
  {
    key: '5',
    value: '5',
  },
];

export const gradeCapData = [
  {
    key: 'No Cap',
    value: 'No Cap',
  },
  {
    key: 'Global Cap',
    value: 'Global Cap',
  },
];

export const feisCapData = [
  {
    key: 'No Cap',
    value: 'No Cap',
  },
  {
    key: 'Global Cap',
    value: 'Global Cap',
  },
  {
    key: 'Level Cap',
    value: 'Level Cap',
  },
];

// Caps count dancers, not competition entries (backend helpers/feisCap.js).
export const capHelpText = {
  'Global Cap': 'Maximum number of dancers. Each dancer counts once, however many competitions they enter.',
  'Level Cap': 'Each dancer counts once: championship if they enter any championship (Prelim, Open, adult championship, a championship solo filed in another group such as Specials, or a championship-only special), otherwise grades (including teams, Tir na nOg and Future Champion specials). Leave a level blank for no limit.',
};

export const lavelCap = [
  {
    key: 'Grades dancers',
    subKey: '(every dancer with no championship entry)',
    value: 'Grades dancers',
  },
  {
    key: 'Championship dancers',
    subKey: '(any championship entry: Prelim, Open, adult, a championship solo in another group, or a championship-only special)',
    value: 'Championship dancers',
  },
];